import { render, staticRenderFns } from "./UploadFilesDialog.vue?vue&type=template&id=b8eb5ba8&scoped=true"
import script from "./UploadFilesDialog.vue?vue&type=script&lang=js"
export * from "./UploadFilesDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadFilesDialog.vue?vue&type=style&index=0&id=b8eb5ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8eb5ba8",
  null
  
)

export default component.exports